"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericLoadManualStatic = exports.GenericLoadManual = void 0;
const utils_1 = require("../utils");
const core_1 = require("../../../core");
const ONE_SECOND = 1000;
class GenericLoadManual {
    constructor() {
        this.lowTTL = ONE_SECOND / 2;
        this.fastConnectionTimeOut = ONE_SECOND * 5;
        this.lowConnectionTimeOut = ONE_SECOND * 60 * 2;
        this.checkVerticalAlreadyLoaded = (verticalId) => {
            var _a;
            return ((_a = window.globals) === null || _a === void 0 ? void 0 : _a[verticalId]) && !!document.querySelectorAll(`[id^="${verticalId}"]`).length;
        };
        this.savePromiseIntoWindow = (verticalId, resolve) => {
            window.globalPromises[verticalId] = () => resolve(window.globals[verticalId]);
        };
        this.getVerticalScripts = (verticalId) => __awaiter(this, void 0, void 0, function* () {
            try {
                const scriptText = yield (0, utils_1.getVerticalRequest)(this.getUrl(verticalId));
                return (0, utils_1.getVerticalSrc)(scriptText);
            }
            catch (e) {
                core_1.Log.warn(e.message);
                return [];
            }
        });
        this.load = (verticalId) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.savePromiseIntoWindow(verticalId, resolve);
                const isVerticalLoaded = this.checkVerticalAlreadyLoaded(verticalId);
                if (!isVerticalLoaded) {
                    const start = new Date().getTime();
                    this.getVerticalScripts(verticalId).then(scripts => {
                        const end = new Date().getTime();
                        const responseTimeMs = end - start;
                        const timeToWaitForMicrofrontedLoad = responseTimeMs < this.lowTTL ? this.fastConnectionTimeOut : this.lowConnectionTimeOut;
                        setTimeout(() => reject(`timeout: ${timeToWaitForMicrofrontedLoad}ms expired. Vertical ${verticalId} doesn't initialize. Please check your network speed`), timeToWaitForMicrofrontedLoad);
                        (0, utils_1.loadVerticalScript)(scripts, verticalId);
                    });
                }
                else {
                    resolve(window.globals[verticalId]);
                }
            });
        });
        if (!window.globalPromises) {
            window.globalPromises = {};
        }
    }
}
exports.GenericLoadManual = GenericLoadManual;
class GenericLoadManualStatic extends GenericLoadManual {
    constructor(variant, projectId) {
        super();
        this.getUrl = (verticalId) => {
            return `/${this.projectId}-${verticalId}-${this.variant}/index.html`;
        };
        this.variant = variant;
        this.projectId = projectId;
    }
}
exports.GenericLoadManualStatic = GenericLoadManualStatic;
//# sourceMappingURL=dynamicLoad.js.map